import { combineReducers, CombinedState } from 'redux'
import { unset } from './auth/session'

import { reducer as auth } from './auth/reducer'
import { reducer as blog } from './blog/reducer'
import { reducer as cms } from './cms/reducer'
import { reducer as common } from './common/reducer'
import { reducer as customer } from './customer/reducer'
import { reducer as quote } from './quote/reducer'

const reducers = {
  auth,
  blog,
  cms,
  common,
  customer,
  quote
}

const appReducer = combineReducers(reducers)
const SESSION_UNSET = unset.toString()
export type RootState = ReturnType<typeof appReducer>

export function rootReducer (state: any, action: any): CombinedState<object> {
  if (action.type === SESSION_UNSET) {
    state = {
      ...state,
      customer: undefined,
      quote: undefined
    }
  }

  return appReducer(state, action)
}
